import React from 'react';
import PropTypes from 'prop-types';

import PrintIcon from '@mui/icons-material/Print';
import { Tooltip } from '@mui/material';

import classes from './iconStyles.module.css';

const OnPrintIcon = ({ onPrint, active = true, tooltip = 'Print' }) => {
    return (
        <Tooltip title={tooltip} placement="right-end">
            <div
                className={`${classes.printIcon} ${!active && classes.disabled}`}
                onClick={active ? onPrint : null}>
                <PrintIcon aria-label="print-icon" role="button" />
            </div>
        </Tooltip>
    );
};

OnPrintIcon.propTypes = {
    onPrint: PropTypes.func,
    active: PropTypes.bool,
    tooltip: PropTypes.string
};

export default OnPrintIcon;
